import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import React, { useEffect, useLayoutEffect, useRef } from 'react';

export const useGetContentStyles = () => {
  const contentDivRef = useRef(null);
  const footerRef = useRef(null);
  const { isMobile } = useVerifyIsMobile(768);
  const hasScroll = isMobile ?
    contentDivRef.current?.scrollHeight >= contentDivRef?.current?.clientHeight :
    contentDivRef.current?.scrollHeight > contentDivRef?.current?.clientHeight


  useLayoutEffect(
    () => {
      const footer = footerRef?.current;
      const contentDiv = contentDivRef?.current;
      if (!footer || !contentDiv) return;
      if (footer.classList.contains('display-footer'))
        footer.classList.remove('display-footer');
      setTimeout(() => {
        footer.classList.add('display-footer');

        if (footer.classList.contains('footer_web--hidden'))
          contentDiv.classList.remove('content_div--with-footer');
        else contentDiv.classList.add('content_div--with-footer');
      }, 2000);

      // WORKAROUND NOTE
      // Se agrega una segunda validacion para los casos donde al mostrar el footer el content de content_div vuelve a cambiar de tamaño
      // En r22 se trabaja en una implementación más robusta de este comportamiento
    },
    [location.pathname],
  );

  useEffect(
    () => {
      if (hasScroll) {
        footerRef.current.classList.remove('fixed-footer');
      } else {
        footerRef.current.classList.add('fixed-footer');
      }
    },
    [hasScroll],
  );

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const setViewportHeight = () => {
      const vh = Number(window.innerHeight);
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setViewportHeight();

    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('load', setViewportHeight);

    return () => {
      document.body.style.overflow = 'visible';
      window.removeEventListener('resize', setViewportHeight);
      window.removeEventListener('load', setViewportHeight);
    };
  }, []);

  return {
    contentDivRef,
    footerRef,
  };
};
